import { Pipe, PipeTransform } from '@angular/core';

const RESOLUTION_STATUS_MAP = new Map<number, string>([
  [0, 'Dispute Write Off'],
  [1, 'Dispute Settled']
]);

@Pipe({
  name: 'auditResolutionStatus',
  standalone: false
})
export class AuditResolutionStatusPipe implements PipeTransform {
  transform(value?: number | null): string {
    if (value == null) {
      return 'Unresolved';
    }

    return RESOLUTION_STATUS_MAP.get(value) ?? 'Unknown';
  }
}
